export const workshopJobEventTypeLabelMap: Map<WorkshopJobEventType, string> =
  new Map([
    ['booked_in', 'Booked In'],
    ['assessment', 'Assessment'],
    ['quotation', 'Quotation'],
    ['quote_approved', 'Quote Approved'],
    ['waiting_for_parts', 'Waiting for Parts'],
    ['repair_started', 'Repair Started'],
    ['completed', 'Completed'],
    ['cancelled', 'Cancelled']
  ]);

export type WorkshopJobEventType =
  | 'booked_in'
  | 'assessment'
  | 'quotation'
  | 'quote_approved'
  | 'waiting_for_parts'
  | 'repair_started'
  | 'completed'
  | 'cancelled';

export interface AssessmentEventDetail {
  assessment: string;
  estimated_labour_hours: number | null;
  estimated_parts_cost: number | null;
  estimated_total_cost: number | null;
}

export interface QuotationEventDetail {
  estimated_total_cost: number;
  work_required: string;
  send_email: boolean;
  email_address: string;
}

export interface QuoteApprovedEventDetail {
  notes: String;
  via_email_link: boolean;
}

export interface WaitingForPartsEventDetail {
  notes: String;
}

export interface RepairStartedEventDetail {
  notes: String;
}

export interface CompletedEventDetail {
  notes: String;
  labour_hours: number;
  labour_cost: number;
}

export interface CancelledEventDetail {
  notes: String;
  labour_hours: number;
  labour_cost: number;
}

export interface WorkshopJobAssessmentEvent
  extends WorkshopJobEventBase<AssessmentEventDetail> {
  type: 'assessment';
}

export interface WaitiningForPartsEvent
  extends WorkshopJobEventBase<WaitingForPartsEventDetail> {
  type: 'waiting_for_parts';
}

export interface RepairStartedEvent
  extends WorkshopJobEventBase<RepairStartedEventDetail> {
  type: 'repair_started';
}

export interface CompletedEvent
  extends WorkshopJobEventBase<CompletedEventDetail> {
  type: 'completed';
}

export interface CancelledEvent
  extends WorkshopJobEventBase<CancelledEventDetail> {
  type: 'cancelled';
}

export interface WorkshopJobQuotationEvent
  extends WorkshopJobEventBase<QuotationEventDetail> {
  type: 'quotation';
}

export interface WorkshopJobQuoteApprovedEvent
  extends WorkshopJobEventBase<QuoteApprovedEventDetail> {
  type: 'quote_approved';
}

export interface WorkshopJobEventBase<DetailType> {
  id: number;
  workshop_job_id: number;
  created_by: number | null;
  type: WorkshopJobEventType;
  details: DetailType;
  deleted_at: string;
  created_at: string;
  updated_at: string;
}
